import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  LineItemState_RequestingReview_getInstance2ojeopd3nid3v as LineItemState_RequestingReview_getInstance,
  LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance,
  LineItemState_NotApproved_getInstance1n0ztla6z4oyz as LineItemState_NotApproved_getInstance,
  LineItemState_Issue_getInstancewwqrry76cukq as LineItemState_Issue_getInstance,
  LineItemState_Disputed_getInstance1ejlicwa0ud20 as LineItemState_Disputed_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
  LineItemState_Resolved_getInstance3gyqdeh0a3lwt as LineItemState_Resolved_getInstance,
  LineItemState_Settled_getInstance301yvu41ltgpc as LineItemState_Settled_getInstance,
  LineItemState_ResolveLater_getInstance12e6r673b4g9c as LineItemState_ResolveLater_getInstance,
  LineItemState_WorkingOnRemedy_getInstanceklan96hlrfx7 as LineItemState_WorkingOnRemedy_getInstance,
  LineItemState_Resolving_getInstancem43rd15e543j as LineItemState_Resolving_getInstance,
} from '../enums.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from '../supportModels.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_DAYS_getInstance3abv9r3rbwkq3 as DurationUnit_DAYS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../timeFormatting.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RemedyCompleteClass;
function RemedyComplete() {
  if (RemedyCompleteClass === VOID) {
    class $ {
      constructor(remedy) {
        this.y8y_1 = remedy;
      }
      z8y(history) {
        return 'Sign-Off ' + (history.m8w() + 1 | 0);
      }
      g8w(history) {
        return history.g8x();
      }
      toString() {
        return 'RemedyComplete(remedy=' + this.y8y_1.toString() + ')';
      }
      hashCode() {
        return this.y8y_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemedyComplete()))
          return false;
        if (!this.y8y_1.equals(other.y8y_1))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForClass($, 'RemedyComplete', VOID, VOID, [NeedsApproval()]);
    RemedyCompleteClass = $;
  }
  return RemedyCompleteClass;
}
var NeedsApprovalClass;
function NeedsApproval() {
  if (NeedsApprovalClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'NeedsApproval', VOID, VOID, [CompletionResponse()]);
    NeedsApprovalClass = $;
  }
  return NeedsApprovalClass;
}
var RequestCompleteClass;
function RequestComplete() {
  if (RequestCompleteClass === VOID) {
    class $ {
      constructor(accessInfo) {
        this.b8z_1 = accessInfo;
      }
      z8y(history) {
        return history.m8w() > 0 ? 'Sign-Off ' + (history.m8w() + 1 | 0) : 'Sign-Off';
      }
      g8w(history) {
        var tmp;
        var tmp0 = history.x8v_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.i1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_1 = element.f8w();
            if (tmp_1 instanceof RequestComplete()) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        if (tmp$ret$0) {
          tmp = LineItemState_RequestingReview_getInstance();
        } else {
          tmp = history.g8x();
        }
        return tmp;
      }
      toString() {
        return 'RequestComplete(accessInfo=' + this.b8z_1.toString() + ')';
      }
      hashCode() {
        return this.b8z_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestComplete()))
          return false;
        if (!this.b8z_1.equals(other.b8z_1))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForClass($, 'RequestComplete', VOID, VOID, [NeedsApproval()]);
    RequestCompleteClass = $;
  }
  return RequestCompleteClass;
}
var MoreInfoClass;
function MoreInfo() {
  if (MoreInfoClass === VOID) {
    class $ {
      z8y(history) {
        return 'More Info';
      }
      g8w(history) {
        return history.h8x();
      }
      toString() {
        return 'MoreInfo';
      }
      hashCode() {
        return 465305069;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MoreInfo()))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForObject($, 'MoreInfo', VOID, VOID, [CompletionResponse()]);
    MoreInfoClass = $;
  }
  return MoreInfoClass;
}
var MoreInfo_instance;
function MoreInfo_getInstance() {
  return MoreInfo_instance;
}
var HandledClass;
function Handled() {
  if (HandledClass === VOID) {
    class $ {
      constructor(credit) {
        this.c8z_1 = credit;
      }
      z8y(history) {
        return withOptionalCredit('Handled', this.c8z_1);
      }
      g8w(history) {
        return history.g8x();
      }
      d8z(credit) {
        return new (Handled())(credit);
      }
      toString() {
        var tmp = this.c8z_1;
        return 'Handled(credit=' + toString_0(tmp == null ? null : new (MonetaryValue())(tmp)) + ')';
      }
      hashCode() {
        var tmp;
        var tmp_0 = this.c8z_1;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = 0;
        } else {
          tmp = MonetaryValue__hashCode_impl_fhcsz2(this.c8z_1);
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Handled()))
          return false;
        var tmp = this.c8z_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.c8z_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForClass($, 'Handled', VOID, VOID, [NeedsApproval()]);
    HandledClass = $;
  }
  return HandledClass;
}
var ForceCompleteClass;
function ForceComplete() {
  if (ForceCompleteClass === VOID) {
    class $ {
      constructor(credit) {
        this.e8z_1 = credit;
      }
      z8y(history) {
        return withOptionalCredit('Force Complete', this.e8z_1);
      }
      g8w(history) {
        return history.g8x();
      }
      d8z(credit) {
        return new (ForceComplete())(credit);
      }
      toString() {
        var tmp = this.e8z_1;
        return 'ForceComplete(credit=' + toString_0(tmp == null ? null : new (MonetaryValue())(tmp)) + ')';
      }
      hashCode() {
        var tmp;
        var tmp_0 = this.e8z_1;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = 0;
        } else {
          tmp = MonetaryValue__hashCode_impl_fhcsz2(this.e8z_1);
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ForceComplete()))
          return false;
        var tmp = this.e8z_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.e8z_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForClass($, 'ForceComplete', VOID, VOID, [NeedsApproval()]);
    ForceCompleteClass = $;
  }
  return ForceCompleteClass;
}
var KeepWorkingClass;
function KeepWorking() {
  if (KeepWorkingClass === VOID) {
    class $ {
      z8y(history) {
        return 'More Work';
      }
      g8w(history) {
        return LineItemState_KeepWorking_getInstance();
      }
      toString() {
        return 'KeepWorking';
      }
      hashCode() {
        return -1689055390;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KeepWorking()))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForObject($, 'KeepWorking', VOID, VOID, [CompletionResponse()]);
    KeepWorkingClass = $;
  }
  return KeepWorkingClass;
}
var KeepWorking_instance;
function KeepWorking_getInstance() {
  return KeepWorking_instance;
}
var ClientResponseClass;
function ClientResponse() {
  if (ClientResponseClass === VOID) {
    class $ {
      constructor(reasons, raiseIssue, fileDispute) {
        reasons = reasons === VOID ? emptySet() : reasons;
        raiseIssue = raiseIssue === VOID ? false : raiseIssue;
        fileDispute = fileDispute === VOID ? null : fileDispute;
        this.o8w_1 = reasons;
        this.p8w_1 = raiseIssue;
        this.q8w_1 = fileDispute;
      }
      z8y(history) {
        var tmp;
        if (!(this.q8w_1 == null)) {
          tmp = 'File Dispute';
        } else {
          if (this.p8w_1) {
            tmp = 'Raise Issue';
          } else {
            var tmp0_safe_receiver = history.x8w();
            if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f8w(), MoreInfo_instance)) {
              tmp = 'Provide Info';
            } else {
              if (!history.t8w()) {
                tmp = 'Mark Not Ready';
              } else {
                var tmp1_subject = history.n8w();
                var tmp_0;
                switch (tmp1_subject == null ? -1 : tmp1_subject.b4_1) {
                  case 0:
                    tmp_0 = 'Mark Not Ready';
                    break;
                  case 1:
                    tmp_0 = 'Resubmit Issue';
                    break;
                  case 2:
                    tmp_0 = 'File Dispute';
                    break;
                  case -1:
                    tmp_0 = 'Response';
                    break;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
                tmp = tmp_0;
              }
            }
          }
        }
        return tmp;
      }
      g8w(history) {
        return !(this.q8w_1 == null) ? LineItemState_Disputed_getInstance() : this.p8w_1 ? LineItemState_Issue_getInstance() : !history.t8w() ? LineItemState_NotApproved_getInstance() : history.g8x();
      }
      f8z(reasons, raiseIssue, fileDispute) {
        return new (ClientResponse())(reasons, raiseIssue, fileDispute);
      }
      g8z(reasons, raiseIssue, fileDispute, $super) {
        reasons = reasons === VOID ? this.o8w_1 : reasons;
        raiseIssue = raiseIssue === VOID ? this.p8w_1 : raiseIssue;
        fileDispute = fileDispute === VOID ? this.q8w_1 : fileDispute;
        return $super === VOID ? this.f8z(reasons, raiseIssue, fileDispute) : $super.f8z.call(this, reasons, raiseIssue, fileDispute);
      }
      toString() {
        return 'ClientResponse(reasons=' + toString(this.o8w_1) + ', raiseIssue=' + this.p8w_1 + ', fileDispute=' + toString_0(this.q8w_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.o8w_1);
        result = imul(result, 31) + getBooleanHashCode(this.p8w_1) | 0;
        result = imul(result, 31) + (this.q8w_1 == null ? 0 : this.q8w_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientResponse()))
          return false;
        if (!equals(this.o8w_1, other.o8w_1))
          return false;
        if (!(this.p8w_1 === other.p8w_1))
          return false;
        if (!equals(this.q8w_1, other.q8w_1))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForClass($, 'ClientResponse', ClientResponse, VOID, [CompletionResponse()]);
    ClientResponseClass = $;
  }
  return ClientResponseClass;
}
var ClientResolutionClass;
function ClientResolution() {
  if (ClientResolutionClass === VOID) {
    class $ {
      z8y(history) {
        return 'Proposal';
      }
      g8w(history) {
        return history.g8x();
      }
      toString() {
        return 'ClientResolution';
      }
      hashCode() {
        return 1514535201;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientResolution()))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForObject($, 'ClientResolution', VOID, VOID, [CompletionResponse()]);
    ClientResolutionClass = $;
  }
  return ClientResolutionClass;
}
var ClientResolution_instance;
function ClientResolution_getInstance() {
  return ClientResolution_instance;
}
var RequestResolveLaterClass;
function RequestResolveLater() {
  if (RequestResolveLaterClass === VOID) {
    class $ {
      z8y(history) {
        return 'Resolve Later';
      }
      g8w(history) {
        return history.h8x();
      }
      toString() {
        return 'RequestResolveLater';
      }
      hashCode() {
        return -1267253851;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestResolveLater()))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForObject($, 'RequestResolveLater', VOID, VOID, [NeedsApproval()]);
    RequestResolveLaterClass = $;
  }
  return RequestResolveLaterClass;
}
var RequestResolveLater_instance;
function RequestResolveLater_getInstance() {
  return RequestResolveLater_instance;
}
var AppealClass;
function Appeal() {
  if (AppealClass === VOID) {
    class $ {
      z8y(history) {
        return 'Appeal';
      }
      g8w(history) {
        return history.g8x();
      }
      toString() {
        return 'Appeal';
      }
      hashCode() {
        return -1289685927;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Appeal()))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForObject($, 'Appeal', VOID, VOID, [NeedsApproval()]);
    AppealClass = $;
  }
  return AppealClass;
}
var Appeal_instance;
function Appeal_getInstance() {
  return Appeal_instance;
}
var RemedyClass;
function Remedy() {
  if (RemedyClass === VOID) {
    class $ {
      constructor(due, credit) {
        var tmp;
        if (due === VOID) {
          // Inline function 'com.lightningkite.now' call
          var tmp_0 = get_default(Companion_instance).d1m();
          // Inline function 'kotlin.time.Companion.days' call
          Companion_getInstance();
          var tmp$ret$1 = toDuration(7, DurationUnit_DAYS_getInstance());
          tmp = tmp_0.u26(tmp$ret$1);
        } else {
          tmp = due;
        }
        due = tmp;
        credit = credit === VOID ? null : credit;
        this.h8z_1 = due;
        this.i8z_1 = credit;
      }
      a8z(history) {
        return history.z8w() ? 'Resolution Plan' : 'Remedy Plan';
      }
      z8y(history) {
        return withOptionalCredit(this.a8z(history) + ' due ' + format(this.h8z_1, Formats_getInstance().j8z_1), this.i8z_1);
      }
      g8w(history) {
        return history.g8x();
      }
      p8z(due, credit) {
        return new (Remedy())(due, credit);
      }
      q8z(due, credit, $super) {
        due = due === VOID ? this.h8z_1 : due;
        credit = credit === VOID ? this.i8z_1 : credit;
        var tmp;
        if ($super === VOID) {
          tmp = this.p8z(due, credit);
        } else {
          var tmp_0 = $super.p8z;
          var tmp_1 = credit;
          tmp = tmp_0.call(this, due, tmp_1 == null ? null : new (MonetaryValue())(tmp_1));
        }
        return tmp;
      }
      toString() {
        var tmp = this.h8z_1.toString();
        var tmp_0 = this.i8z_1;
        return 'Remedy(due=' + tmp + ', credit=' + toString_0(tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) + ')';
      }
      hashCode() {
        var result = this.h8z_1.hashCode();
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.i8z_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.i8z_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Remedy()))
          return false;
        if (!this.h8z_1.equals(other.h8z_1))
          return false;
        var tmp = this.i8z_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.i8z_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Remedy', Remedy, VOID, [NeedsApproval()]);
    RemedyClass = $;
  }
  return RemedyClass;
}
var CreditClass;
function Credit() {
  if (CreditClass === VOID) {
    class $ {
      constructor(credit) {
        this.r8z_1 = credit;
      }
      z8y(history) {
        return 'Credit, ' + MonetaryValue__toString_impl_xslc77(this.r8z_1);
      }
      a8z(history) {
        return 'Credit';
      }
      g8w(history) {
        return history.g8x();
      }
      s8z(credit) {
        return new (Credit())(credit);
      }
      toString() {
        return 'Credit(credit=' + MonetaryValue__toString_impl_xslc77(this.r8z_1) + ')';
      }
      hashCode() {
        return MonetaryValue__hashCode_impl_fhcsz2(this.r8z_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Credit()))
          return false;
        if (!(this.r8z_1 === other.r8z_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Credit', VOID, VOID, [NeedsApproval()]);
    CreditClass = $;
  }
  return CreditClass;
}
var RequestSiteVisitClass;
function RequestSiteVisit() {
  if (RequestSiteVisitClass === VOID) {
    class $ {
      constructor(time) {
        time = time === VOID ? null : time;
        this.t8z_1 = time;
      }
      z8y(history) {
        return 'Request Job Visit' + (!(this.t8z_1 == null) ? 'at ' + format(this.t8z_1, Formats_getInstance().k8z_1) : '');
      }
      a8z(history) {
        return 'Request Job Visit';
      }
      g8w(history) {
        return history.h8x();
      }
      toString() {
        return 'RequestSiteVisit(time=' + toString_0(this.t8z_1) + ')';
      }
      hashCode() {
        return this.t8z_1 == null ? 0 : this.t8z_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestSiteVisit()))
          return false;
        if (!equals(this.t8z_1, other.t8z_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestSiteVisit', RequestSiteVisit, VOID, [NeedsApproval()]);
    RequestSiteVisitClass = $;
  }
  return RequestSiteVisitClass;
}
var AcceptClass;
function Accept() {
  if (AcceptClass === VOID) {
    class $ {
      constructor(proposal, accessInfo) {
        this.r8w_1 = proposal;
        this.s8w_1 = accessInfo;
      }
      z8y(history) {
        var tmp;
        var tmp_0 = this.r8w_1;
        if (tmp_0 instanceof RequestSiteVisit()) {
          tmp = 'Confirm Visit';
        } else {
          if (get_isSignOff(this.r8w_1)) {
            tmp = 'Approve Work';
          } else {
            tmp = 'Accept ' + this.r8w_1.z8y(history.j8x(this.s8w_1.q54_1));
          }
        }
        return tmp;
      }
      g8w(history) {
        var tmp0_subject = this.r8w_1;
        var tmp;
        if (tmp0_subject instanceof Remedy()) {
          tmp = history.z8w() ? LineItemState_Resolving_getInstance() : LineItemState_WorkingOnRemedy_getInstance();
        } else {
          if (equals(tmp0_subject, RequestResolveLater_instance)) {
            tmp = LineItemState_ResolveLater_getInstance();
          } else {
            if (tmp0_subject instanceof RequestSiteVisit()) {
              tmp = history.h8x();
            } else {
              var tmp1_subject = history.n8w();
              var tmp_0;
              switch (tmp1_subject == null ? -1 : tmp1_subject.b4_1) {
                case -1:
                  tmp_0 = LineItemState_Complete_getInstance();
                  break;
                case 0:
                  tmp_0 = LineItemState_Resolved_getInstance();
                  break;
                case 1:
                  tmp_0 = LineItemState_Resolved_getInstance();
                  break;
                case 2:
                  tmp_0 = LineItemState_Settled_getInstance();
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp = tmp_0;
            }
          }
        }
        return tmp;
      }
      toString() {
        return 'Accept(proposal=' + toString(this.r8w_1) + ', accessInfo=' + this.s8w_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.r8w_1);
        result = imul(result, 31) + this.s8w_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Accept()))
          return false;
        if (!equals(this.r8w_1, other.r8w_1))
          return false;
        if (!this.s8w_1.equals(other.s8w_1))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForClass($, 'Accept', VOID, VOID, [CompletionResponse()]);
    AcceptClass = $;
  }
  return AcceptClass;
}
var DenyClass;
function Deny() {
  if (DenyClass === VOID) {
    class $ {
      z8y(history) {
        return 'Deny';
      }
      g8w(history) {
        return history.g8x();
      }
      toString() {
        return 'Deny';
      }
      hashCode() {
        return 217730902;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Deny()))
          return false;
        return true;
      }
    }
    protoOf($).a8z = shortDisplayName;
    initMetadataForObject($, 'Deny', VOID, VOID, [CompletionResponse()]);
    DenyClass = $;
  }
  return DenyClass;
}
var Deny_instance;
function Deny_getInstance() {
  return Deny_instance;
}
function shortDisplayName(history) {
  return this.z8y(history);
}
var CompletionResponseClass;
function CompletionResponse() {
  if (CompletionResponseClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CompletionResponse');
    CompletionResponseClass = $;
  }
  return CompletionResponseClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.y8s_1.f2();
}
function LineItemConcern$Companion$_anonymous__rl239y() {
  return createSimpleEnumSerializer('com.crowpay.completionResponse.LineItemConcern', values());
}
var LineItemConcern_Incomplete_instance;
var LineItemConcern$QualityConcernClass;
function LineItemConcern$QualityConcern() {
  if (LineItemConcern$QualityConcernClass === VOID) {
    class $ extends LineItemConcern() {
      static z8z() {
        var $this = this.e90('QualityConcern', 1, 'Quality Concern', '#C8D1F8');
        LineItemConcern_QualityConcern_instance = $this;
        $this.y8z_1 = 'Quality';
        return $this;
      }
      f90() {
        return this.y8z_1;
      }
    }
    initMetadataForClass($, 'QualityConcern');
    LineItemConcern$QualityConcernClass = $;
  }
  return LineItemConcern$QualityConcernClass;
}
var LineItemConcern_QualityConcern_instance;
var LineItemConcern_Other_instance;
function values() {
  return [LineItemConcern_Incomplete_getInstance(), LineItemConcern_QualityConcern_getInstance(), LineItemConcern_Other_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.y8s_1 = lazy(tmp_0, LineItemConcern$Companion$_anonymous__rl239y);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  LineItemConcern_initEntries();
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var LineItemConcern_entriesInitialized;
function LineItemConcern_initEntries() {
  if (LineItemConcern_entriesInitialized)
    return Unit_instance;
  LineItemConcern_entriesInitialized = true;
  LineItemConcern_Incomplete_instance = LineItemConcern().e90('Incomplete', 0, 'Incomplete', '#FCA899');
  LineItemConcern_QualityConcern_instance = LineItemConcern$QualityConcern().z8z();
  LineItemConcern_Other_instance = LineItemConcern().e90('Other', 2, 'Other', '#FBEBBC');
  Companion_getInstance_0();
}
var $ENTRIES;
var LineItemConcernClass;
function LineItemConcern() {
  if (LineItemConcernClass === VOID) {
    class $ extends Enum() {
      static e90(name, ordinal, displayName, displayColor) {
        var $this = this.c4(name, ordinal);
        $this.c90_1 = displayName;
        $this.d90_1 = displayColor;
        return $this;
      }
      g90() {
        return this.c90_1;
      }
      h90() {
        return this.d90_1;
      }
      i90() {
        return this.b4_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'LineItemConcern', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_0});
    LineItemConcernClass = $;
  }
  return LineItemConcernClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.z8s_1.f2();
}
function DisputeType$Companion$_anonymous__25efgv() {
  return createSimpleEnumSerializer('com.crowpay.completionResponse.DisputeType', values_0());
}
var DisputeType_LineItem_instance;
var DisputeType_ProjectWide_instance;
function values_0() {
  return [DisputeType_LineItem_getInstance(), DisputeType_ProjectWide_getInstance()];
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.z8s_1 = lazy(tmp_0, DisputeType$Companion$_anonymous__25efgv);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  DisputeType_initEntries();
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var DisputeType_entriesInitialized;
function DisputeType_initEntries() {
  if (DisputeType_entriesInitialized)
    return Unit_instance;
  DisputeType_entriesInitialized = true;
  DisputeType_LineItem_instance = DisputeType().m90('LineItem', 0, 'Work Item');
  DisputeType_ProjectWide_instance = DisputeType().m90('ProjectWide', 1, 'Project Wide');
  Companion_getInstance_1();
}
var DisputeTypeClass;
function DisputeType() {
  if (DisputeTypeClass === VOID) {
    class $ extends Enum() {
      static m90(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.l90_1 = displayName;
        return $this;
      }
      g90() {
        return this.l90_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'DisputeType', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_1});
    DisputeTypeClass = $;
  }
  return DisputeTypeClass;
}
function get_isSignOff(_this__u8e3s4) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof RequestComplete()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof RemedyComplete();
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function withOptionalCredit(_this__u8e3s4, credit) {
  var tmp;
  var tmp_0 = credit;
  if (!((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null)) {
    tmp = ' + ' + MonetaryValue__toString_impl_xslc77(credit);
  } else {
    tmp = '';
  }
  return _this__u8e3s4 + tmp;
}
function LineItemConcern_Incomplete_getInstance() {
  LineItemConcern_initEntries();
  return LineItemConcern_Incomplete_instance;
}
function LineItemConcern_QualityConcern_getInstance() {
  LineItemConcern_initEntries();
  return LineItemConcern_QualityConcern_instance;
}
function LineItemConcern_Other_getInstance() {
  LineItemConcern_initEntries();
  return LineItemConcern_Other_instance;
}
function DisputeType_LineItem_getInstance() {
  DisputeType_initEntries();
  return DisputeType_LineItem_instance;
}
function DisputeType_ProjectWide_getInstance() {
  DisputeType_initEntries();
  return DisputeType_ProjectWide_instance;
}
//region block: init
MoreInfo_instance = new (MoreInfo())();
KeepWorking_instance = new (KeepWorking())();
ClientResolution_instance = new (ClientResolution())();
RequestResolveLater_instance = new (RequestResolveLater())();
Appeal_instance = new (Appeal())();
Deny_instance = new (Deny())();
//endregion
//region block: exports
export {
  Accept as Accept733y3zepx42g,
  Appeal as Appealdu3t1bemwr4j,
  ClientResolution as ClientResolution1kcdgkwzeikik,
  ClientResponse as ClientResponse3rdi8ggal48xs,
  Credit as Credit2hxrirfggfkql,
  ForceComplete as ForceCompletemak8s8g9i3mp,
  Handled as Handled3ngpo7bepl0ux,
  MoreInfo as MoreInfof0qn3z2grweu,
  NeedsApproval as NeedsApproval1ftfboe6wlgyi,
  RemedyComplete as RemedyComplete1j0nrocri3mi3,
  Remedy as Remedy1wqpxp6byw9t6,
  RequestComplete as RequestComplete2fbpvksxlxjbf,
  RequestSiteVisit as RequestSiteVisit1o0qmklsbtvus,
  DisputeType as DisputeType169p3tc7g9isk,
  get_entries as get_entries2nzs7h371ziik,
  get_isSignOff as get_isSignOff22izp8i5fus79,
  withOptionalCredit as withOptionalCreditlx9k9tf97u9p,
  DisputeType_LineItem_getInstance as DisputeType_LineItem_getInstanceq2lrx3mzykb,
  DisputeType_ProjectWide_getInstance as DisputeType_ProjectWide_getInstance2cdu0u5z6ld8p,
  Appeal_instance as Appeal_instance3s9wpeu612ekq,
  ClientResolution_instance as ClientResolution_instance7vhdzajvvypa,
  Deny_instance as Deny_instance20z4jsuzv3f53,
  KeepWorking_instance as KeepWorking_instance1l6z7q2tbtqni,
  MoreInfo_instance as MoreInfo_instance2thszg9d7ysff,
  RequestResolveLater_instance as RequestResolveLater_instance1haqv4qpxez7b,
  Companion_getInstance_1 as Companion_getInstance1qsusdia96csy,
  Companion_getInstance_0 as Companion_getInstance2lamxtrpb4qa0,
};
//endregion

//# sourceMappingURL=CompletionResponse.mjs.map
